import React from "react";
import { defaultTheme } from "../styles/themes/defaultTheme";
import { FaPlus } from "react-icons/fa";
import TooltipButton from "../components/Tools/TooltipButton.tsx";

export function CreateButton({ onClick, label, title }) {
    return (
        <TooltipButton title={title}>
            <button
                style={{
                    background: defaultTheme.colors.accent,
                    color: 'white',
                    padding: "7px 10px"
                }}
                className='btn j_r_create j_req_create j_u_create'
                onClick={onClick}>
                <div className='d-flex flex-row align-items-center gap-2' >
                    <FaPlus />
                    {label}
                </div>
            </button>
        </TooltipButton>
    )
}

export default CreateButton;